<template>
  <div class="sign_in login_common">
    <nav-top nav-title="회원가입"/>
    <div class="section flex_column_center">
      <el-form ref="form" :model="form" :rules="rules" class="form">
        <el-form ref="form2" :model="form" :rules="rules2" class="form">
          <el-form-item prop="username">
            <el-input v-model="form.username" type="text" placeholder="아이디 (이메일 주소)" @keyup.native="handleInputUsername" @blur="handleInputBlur" />
          </el-form-item>
        </el-form>
        <el-button v-waves icon="el-icon-check" :class="[checkUsernameBtn? 'btn_check_on':'']" class="btn_check_big" @click="handleCheckDuplicatedId">중복확인</el-button>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="비밀번호" maxlength="20" @keyup.native="getConfirmBtnStatus" @blur="handleInputBlur" />
        </el-form-item>
        <el-form-item prop="passwordCheck">
          <el-input v-model="form.passwordCheck" type="password" placeholder="비밀번호 확인" maxlength="20" @keyup.native="getConfirmBtnStatus" @blur="handleInputBlur" />
        </el-form-item>
        <p class="tip">
          8~20자 이내로 설정해주세요.
        </p>
        <el-form-item prop="name">
          <el-input v-model="form.name" type="text" placeholder="이름" @keyup.native="getConfirmBtnStatus" @blur="handleInputBlur" />
        </el-form-item>
        <el-form-item prop="userTel">
          <el-input v-model="form.userTel" type="number" pattern="\d*" placeholder="휴대폰 (숫자 입력)" maxlength="11" @keydown.native="handleInputNumber" @keyup.native="getConfirmBtnStatus" @blur="handleInputBlur" />
        </el-form-item>
        <p class="tip">
          아이디/비밀번호 찾기 시 회원 인증을 위해 사용됩니다.<br/>
          이름, 휴대폰 번호를 정확하게 입력해주세요.
        </p>
        <el-button v-waves icon="el-icon-check" :class="[checkAgreeBtn? 'btn_check_on':'']" class="btn_check_big" @click="handleCheckAgreeAll">약관동의</el-button>
        <div class="check_group">
          <div class="flex_between">
            <el-checkbox v-model="agreeService" @change="changeChangeAgree">서비스 이용 약관</el-checkbox>
            <!-- <router-link class="btn_link flex_row_center" to="/terms">
              <p class="btn_content">보기</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
            </router-link> -->
            <div class="btn_link flex_row_center">
              <p class="btn_content" v-on:click="showTerms(0)">보기</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
            </div>
          </div>
          <div class="flex_between">
            <el-checkbox v-model="agreePrivacy" @change="changeChangeAgree">개인정보 수집 및 활용</el-checkbox>
            <!-- <router-link class="btn_link flex_row_center" to="/terms">
              <p class="btn_content">보기</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
            </router-link> -->
            <div class="btn_link flex_row_center">
              <p class="btn_content" v-on:click="showTerms(1)">보기</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
            </div>
          </div>
        </div>
      </el-form>
      <el-button v-waves :disabled="!confirmBtnOn" class="btn_big" @click="confirmSignIn">확인</el-button>
    </div>
    <terms-container :show.sync="termsShow" :type="termsType" />
  </div>
</template>

<script>
  import NavTop from '@/components/navTop'
  import waves from '@/directive/waves'
  import TermsContainer from '@/components/terms'

  import { login, getUserInfo, signup, checkDuplicatedId } from '@/http/api/account'

  let app = null

  export default {
    name: 'SignIn',
    directives: { waves },
    components: { NavTop, TermsContainer },
    data () {
      var validateUsername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('아이디를 입력해주세요.'));
        } else if (this.isDuplicatedUsername) {
          callback(new Error('사용할 수 없는 아이디입니다.'));
        } else {
          callback();
        }
      }
      var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('확인 비밀번호를 입력해주세요.'));
        } else if (value !== this.form.password) {
          callback(new Error('비밀번호가 일치하지 않습니다.'));
        } else {
          callback();
        }
      }
      return {
        httpTimestamp: 0,
        form: {
          username: '',
          password: '',
          passwordCheck: '',
          name: '',
          userTel: '',
          snsConnYn: 'N',
          snsTyp: '',
          snsId: '',
          svcTermAgreeYn: 'Y',
          prvcTermAgreeYn: 'Y'
        },
        rules: {
          username: [
            { required: true, message: '아이디를 입력해주세요.', trigger: 'blur' },
            { pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: '아이디를 이메일 형식으로 입력해주세요.', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '비밀번호를 입력해주세요.', trigger: 'blur' },
            { min: 8, max: 20, message: '8~20자 이내로 설정해주세요.', trigger: 'blur' }
          ],
          passwordCheck: [{ required: true, validator: validatePassword, trigger: 'blur' }],
          name: [{ required: true, message: '이름을 입력해주세요.', trigger: 'blur' }],
          userTel: [
            { required: true, message: '휴대폰 번호를 입력해주세요.', trigger: 'blur' },
            { min: 11, max: 11, message: '휴대폰 번호를 올바른 형식으로 입력해주세요.', trigger: 'blur' }
          ]
        },
        rules2: {
          username: [
            { required: true, validator: validateUsername, trigger: 'blur' },
            { pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: '아이디를 이메일 형식으로 입력해주세요.', trigger: 'blur' }
          ]
        },
        isDuplicatedUsername: false,
        checkUsernameBtn: false,
        checkAgreeBtn: false,
        agreeService: false,
        agreePrivacy: false,
        confirmBtnOn: false,
        termsShow: false,
        termsType: 0
      }
    },
    created () {
      app = this
    },
    methods: {
      confirmSignIn () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.httpTimestamp = (new Date).getTime()
            this.$showCustomLoading()

            signup(this.form).then(signupResponse => {
              setTimeout(function() {
                app.$dismissCustomLoading()

                if (signupResponse.success) {
                  app.$customAlert({
                    message: '회원가입이 완료되었습니다.',
                    success: () => {
                      app.httpTimestamp = (new Date).getTime()
                      app.$showCustomLoading()

                      login(app.form.username, app.form.password).then(tokenResponse => {
                        getUserInfo(tokenResponse.accessToken).then(userResponse => {
                          setTimeout(function() {
                            app.$dismissCustomLoading()

                            app.$store.dispatch('setToken', tokenResponse.accessToken)
                            app.$store.dispatch('setId', userResponse.id)
                            app.$store.dispatch('setName', userResponse.name)
                            app.$store.dispatch('setUsername', userResponse.username)

                            app.$router.push({ name: 'index' })
                          }, 1000 - ((new Date).getTime() - app.httpTimestamp))

                          // console.log(this.$store.getters.token)
                          // console.log(this.$store.getters.id)
                          // console.log(this.$store.getters.name)
                          // console.log(this.$store.getters.username)
                        }).catch(function(error) {
                          setTimeout(function() {
                            app.$dismissCustomLoading()
                          }, 1000 - ((new Date).getTime() - app.httpTimestamp))
                        })
                      }).catch(function(error) {
                        setTimeout(function() {
                          app.$dismissCustomLoading()
                        }, 1000 - ((new Date).getTime() - app.httpTimestamp))
                      })
                    }
                  })
                }
              }, 1000 - ((new Date).getTime() - app.httpTimestamp))
            }).catch(function(error) {
              setTimeout(function() {
                app.$dismissCustomLoading()
              }, 1000 - ((new Date).getTime() - app.httpTimestamp))
            })
          }
        })
      },
      handleCheckDuplicatedId () {
        this.$refs['form2'].validate((valid) => {
          if (valid) {
            this.httpTimestamp = (new Date).getTime()
            this.$showCustomLoading()

            checkDuplicatedId(this.form.username).then(response => {
              setTimeout(function() {
                app.$dismissCustomLoading()

                if (response.checkFlag === 'false') {
                  app.isDuplicatedUsername = false
                  app.checkUsernameBtn = true
                  app.getConfirmBtnStatus()
                } else {
                  app.isDuplicatedUsername = true
                  app.checkUsernameBtn = false
                  app.getConfirmBtnStatus()

                  app.$refs['form2'].validate((valid) => {
                    if (!valid) {
                      app.isDuplicatedUsername = false
                    }
                  })
                }
              }, 1000 - ((new Date).getTime() - app.httpTimestamp))
            }).catch(function (error) {
              setTimeout(function() {
                app.$dismissCustomLoading()

                app.checkUsernameBtn = false
                app.getConfirmBtnStatus()
              }, 1000 - ((new Date).getTime() - app.httpTimestamp))
            })
          } else {
            this.isDuplicatedUsername = false
            this.checkUsernameBtn = false
            this.getConfirmBtnStatus()
          }
        })
      },
      handleInputUsername () {
        this.isDuplicatedUsername = false
        this.checkUsernameBtn = false
        this.getConfirmBtnStatus()
      },
      changeChangeAgree () {
        if (this.agreeService === true && this.agreePrivacy === true) {
          this.checkAgreeBtn = true
        } else {
          this.checkAgreeBtn = false
        }
        this.getConfirmBtnStatus()
      },
      handleCheckUserTel () {
        this.getConfirmBtnStatus()
      },
      handleCheckAgreeAll () {
        if (this.checkAgreeBtn === false) {
          this.agreeService = true
          this.agreePrivacy = true
          this.checkAgreeBtn = true
        } else {
          this.agreeService = false
          this.agreePrivacy = false
          this.checkAgreeBtn = false
        }
        this.getConfirmBtnStatus()
      },
      getConfirmBtnStatus () {
        if (this.form.username !== '' &&
            this.form.password !== '' &&
            this.form.password.length >= 8 &&
            this.form.passwordCheck !== '' &&
            this.form.passwordCheck.length >= 8 &&
            this.form.password === this.form.passwordCheck &&
            this.form.name !== '' &&
            this.form.userTel !== '' &&
            this.form.userTel.length === 11 &&
            this.checkUsernameBtn === true &&
            this.checkAgreeBtn === true) {
          this.confirmBtnOn = true
        } else {
          this.confirmBtnOn = false
        }
      },
      handleInputNumber (event) {
        if (!(event.keyCode === 8 || event.keyCode === 46 || (event.keyCode >= 35 && event.keyCode <= 40) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
          event.preventDefault()
        }
      },
      handleInputBlur () {
        document.body.scrollTop = document.body.scrollTop
      },
      showTerms (index) {
        this.termsShow = true
        this.termsType = index
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Account/Signup.vue